const upload = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="m8 4 5.434 5.423-1.01 1.119-3.662-3.67V16H7.25V6.873l-3.663 3.669-1.01-1.12zm8-4v6.183h-1.5V1.5h-13v4.683H0V0z"/></svg>',
};

export { upload as default };
